
import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const ContactCTA = () => {
  return (
    <section className="section-padding bg-gradient-to-r from-slate-900/90 via-slate-900/80 to-blue-950/90 text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-white/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center animate-on-scroll">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium mb-8">
            <Sparkles size={16} className="mr-2" />
            Ready to Get Started?
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
            Transform Your Business with 
            <span className="block mt-2">Cutting-Edge Technology</span>
          </h2>
          
          <p className="text-xl md:text-2xl mb-12 opacity-90 max-w-3xl mx-auto leading-relaxed">
            Contact us today to discuss how our innovative IT solutions can help you achieve 
            your business goals and stay ahead of the competition.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link 
              to="/contact" 
              className="bg-white text-primary px-10 py-5 rounded-2xl font-semibold inline-flex items-center hover:bg-white/90 transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 text-lg group"
            >
              Get in Touch
              <ArrowRight size={24} className="ml-3 transition-transform group-hover:translate-x-1" />
            </Link>
            
            <Link 
              to="/services" 
              className="border-2 border-white text-white px-10 py-5 rounded-2xl font-semibold inline-flex items-center hover:bg-white hover:text-primary transition-all duration-300 text-lg"
            >
              View Our Services
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 pt-12 border-t border-white/20">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">24/7</div>
              <div className="text-white/80">Support Available</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">100%</div>
              <div className="text-white/80">Client Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">Fast</div>
              <div className="text-white/80">Project Delivery</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
